import { createSlice } from "@reduxjs/toolkit";
import { fetchAccountsItems } from "./AccountsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAccountsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccountsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAccountsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default accountsSlice.reducer;